// extracted by mini-css-extract-plugin
module.exports = {"underline":"styles_underline__LzEsB","underline-fixed":"styles_underline-fixed__LO3pl"};